import { Outlet, Navigate } from "react-router-dom";
import { setAuthenticate } from "../api";
import Navbar from "../components/Navbar";
import { useSelector } from "react-redux";
import { automationTokenSet } from "api/automation.api";

const PrivateRoutes = () => {
  const { user } = useSelector((state) => state.auth);

  // Check if user exists and has a token
  if (!user || !user.tokens) {
    return <Navigate to="/login" />;
  }

  try {
    // Decode the JWT token and get its payload (middle part)
    const data = JSON.parse(atob(user.tokens.split(".")[1]));

    // Check if the token is expired (ensure data.exp exists and is a valid number)
    const isValidToken = data.exp && data.exp * 1000 > new Date().getTime();

    if (isValidToken) {
      setAuthenticate(user.tokens); // Store token if valid
      automationTokenSet(user.tokens)
      return (
        <>
          <Navbar />
          <Outlet />
        </>
      );
    } else {
      localStorage.removeItem("user"); // Clear user data if token is invalid
      return <Navigate to="/login" />;
    }
  } catch (error) {
    // Handle cases where the token is malformed or cannot be decoded
    console.error("Error decoding token:", error);
    localStorage.removeItem("user"); // Clear user data if error occurs
    return <Navigate to="/login" />;
  }
};

export default PrivateRoutes;
